import dsBridge from 'dsbridge';

const wechatBtn = document.querySelector('.wechat');
const phoneBtn = document.querySelector('.phone');
const topicPhoneBtn = document.querySelector('.phone_button')


if (topicPhoneBtn) {
  topicPhoneBtn.addEventListener('click', () => {
    dsBridge.call('lbBIEventRecord', {
      type: '1',
      data: {
        type: '1',
        control_id: '1',
        object_id: '40011'
      }
    })
  })
}

if (wechatBtn) {
  wechatBtn.addEventListener('click', () => {
    dsBridge.call('lbBIEventRecord', {
      type: '1',
      data: {
        type: '1',
        control_id: '1',
        object_id: '40012'
      }
    })
  })
}

if (phoneBtn) {
  phoneBtn.addEventListener('click', () => {
    dsBridge.call('lbBIEventRecord', {
      type: '1',
      data: {
        type: '1',
        control_id: '2',
        object_id: '40012'
      }
    })
  })
}